export default __webpack_public_path__ + "static/media/config_colour.c1383f7e.svg";